import React from 'react'

class Mobile extends React.Component {

    componentWillMount () {
        // window.location = 'https://play.google.com/store/apps/details?id=com.mrjotto'
        // window.location = ''
    }

    render() {
        return (
            <div style={{ marginTop: '120px', textAlign: 'center', color: '#fff' }}>
                <title>Mr Jotto | Mobile</title>
                <h1>Mobile app</h1>
                <p>Please check out our mobile app!</p>
                <p>Copyright &copy; 2018 nomo studios, llc. All rights reserved.</p>
            </div>
        )
    }
}

export default Mobile



/** WEBPACK FOOTER **
 ** ./src/containers/Mobile/mobile.js
 **/